import React from "react";

interface PhoneCellProps {
    phone: string;
}

export const PhoneCell: React.FC<PhoneCellProps> = ({ phone }) => {
    return <span>{phone}</span>;
};
